import React, { createContext, useState, useContext } from 'react';
import defaultSpinningDisk from "../images/defaultSpinningDisk.jpg"; // Adjust the path as necessary

const ImageContext = createContext();

export const useImageContext = () => useContext(ImageContext);

export const ImageProvider = ({ children }) => {
    const [currentImage, setCurrentImage] = useState(defaultSpinningDisk);
    const [uploadedImage, setUploadedImage] = useState(defaultSpinningDisk); // Set defaultSpinningDisk as initial value
    const [imageName, setImageName] = useState('example.jpg'); // Update this to reflect the default image name
    const [crop, setCrop] = useState({ x: 0, y: -20 });
    const [zoom, setZoom] = useState(2.0);

    return (
        <ImageContext.Provider value={{ currentImage, setCurrentImage, uploadedImage, setUploadedImage, imageName, setImageName, crop, setCrop, zoom, setZoom }}>
            {children}
        </ImageContext.Provider>
    );
};